import * as yup from "yup"

export const shippingSchema = yup.object().shape({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  address: yup.string().required(),
  address2: yup.string(),
  postalCode: yup.string().required(),
  city: yup.string().required(),
  country: yup.string().required(),
  phone: yup.string().required(),
  notes: yup.string(),
})
